const HorizontalScroll = ({ children }) => (
  <div style={{
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: '20px',
    padding: '10px 0'
  }}>
    {children}
  </div>
);

export  default HorizontalScroll;